import { getStore } from 'owa-mail-store';
import { action } from 'satcheljs/lib/legacy';
export default action('setClientOptedIn')(function setOptedIn(optedIn) {
    getStore().clientOptedIn = optedIn;
});
//# sourceMappingURL=setClientOptedIn.js.map